import React from "react";
import { Link, Outlet } from "react-router-dom";
import Footer from "../Footer";
import SecondNavbar from "../SecondNavbar";
import Navbar from "../Navbar";
import Breadcrumbs from "../Partials/Breadcrumbs";
import { useSelector } from "react-redux";

function CustomLayout() {
  const token = useSelector((state) => state.dropdown.token);

  return (
    <>
      <div className="bg-[#EAEFFB] h-full">
        <div className="border-b bg-[#FFFFFF]">
          <Navbar />
        </div>
        <SecondNavbar />
        <Breadcrumbs />
        <Outlet />
        <Footer />
      </div>
    </>
  );
}

export default CustomLayout;
